import lang from "@/views/modules/Invitees/language/en";

//import Editor from '@tinymce/tinymce-vue';

export default {
    name: "new-invitee",
   
    components: {
     //   'editor': Editor,
    },
    data() {
        return {
            loading: true,
            invitee: {},
            lang:[],
        }
    },
    mounted() {
        this.lang = lang;
    },
    methods: {
        saveInvitee() {
            const self = this;
            self.loading = true;
            axios.post('api/modules/invitees', self.invitee).then(function (response) {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data saved correctly').toString(),
                    type: 'success'
                });
                self.$router.push('/modules/invitees/' + response.data.invitee.id + '/edit');
            }).catch(function () {
                self.loading = false;
            });
        },
    }
}